import { FC } from 'react';

import Link from 'next/link';

import styles from './BreadCrumbs.module.scss';

type Props = {
  breadCrumbs: {
    label: string;
    url: string;
  }[];
};

const BreadCrumbs: FC<Props> = ({ breadCrumbs }) => {
  return (
    <div className={styles.bread_crumbs}>
      <ul className={styles.bread_crumbs_list}>
        {breadCrumbs &&
          breadCrumbs.length > 0 &&
          breadCrumbs.map((breadCrumb, i, array) => {
            return (
              <li className={styles.bread_crumbs_item} key={i}>
                {i === array.length - 1 ? (
                  breadCrumb.label
                ) : (
                  <Link href={breadCrumb.url} prefetch={false}>
                    {breadCrumb.label}
                  </Link>
                )}
              </li>
            );
          })}
      </ul>
    </div>
  );
};

export default BreadCrumbs;
